import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
`;

export const StyledSkeleton = styled.div`
    background-color: ${props => props.theme.C_FIELD_line_der};
    background-image: linear-gradient(
            90deg,
            ${props => props.theme.C_FIELD_line_der} 0%,
            ${props => props.theme.C_FIELD_table_line} 50%,
            ${props => props.theme.C_FIELD_line_der} 100%
    );
    background-size: 200% 100%;
    animation: ${shimmer} 2.5s linear infinite;
    border-radius: 6px;

    border-radius: ${props => props.theme.borderRadius};
`;